import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";
const mediaDomain = process.env.REACT_APP_MEDIA_DOMAIN;

export function postAgent22Api(params) {
  return authPost(`${baseUrl}/Agent22.ashx`, params);
}

export function createGame(params, url) {
  return authFormPost(url, params);
}
